import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LinearProgress, Typography } from "@mui/material";

const styles = {
  fullWidth: { width: "100%" },
  maxSize: { width: "100%", height: "100%" },
};

export default function ProcentBar(props) {
  const [procent, setProgress] = useState(props.procent || 0);

  useEffect(() => {
    setProgress(props.procent);
  }, [props.procent]);

  return (
    <div style={styles.fullWidth}>
      <LinearProgress variant="determinate" value={procent} />
      <Typography variant="body2"
        //color="primary" 
        align="center">
        {procent}%
      </Typography>
    </div>
  );
}

ProcentBar.propTypes = {
  procent: PropTypes.number,
  isLoading: PropTypes.bool,
};
